import PptxGenJS from 'pptxgenjs';
import { LabelValue } from '@/features/files/types';
import {
  addBulletsSection,
  addConfidentialDisclaimer,
  addProjectBadge,
  addSlideTitle,
  regularSlideGradient,
} from '../template-parts';
import { toBulletRuns } from '../helpers';
import { PPTImageManager } from '../helpers/image-manager';

interface TopcoSections {
  portfolioSummary?: LabelValue[];
  financialHighlights?: LabelValue[];
  teamGovernance?: LabelValue[];
}

interface TopcoInfoData {
  projectTitle?: string;
  project: TopcoSections;
}

const topcoPositioning = {
  hBody: 1.48,
  portfolio: {
    yTitle: 1.71,
    yBody: 2.04,
  },
  financial: {
    yTitle: 4.96,
    yBody: 5.26,
  },
  team: {
    yTitle: 8.2,
    yBody: 8.5,
  },
};

export function topcoInfoSlide(pptx: PptxGenJS, data: TopcoInfoData, imageManager: PPTImageManager) {
  const slide = pptx.addSlide();
  const slideImages = {
    logoBlack: imageManager.get('logo-black'),
    portfolio: imageManager.get('pie'),
    financial: imageManager.get('chart'),
    team: imageManager.get('users'),
  };
  const { hBody, portfolio, financial, team } = topcoPositioning;
  const { portfolioSummary = [], financialHighlights = [], teamGovernance = [] } = data.project ?? {};

  regularSlideGradient(slide);

  if (slideImages.logoBlack) {
    slide.addImage({
      data: slideImages.logoBlack,
      x: 5.26,
      y: 0.24,
      w: 1.92,
      h: 0.58,
    });
  }

  const badgeText = (data.projectTitle ?? 'PROJECT XXX').toUpperCase();
  addProjectBadge(slide, badgeText);
  addSlideTitle(slide, 'Company Details');

  const portfolioBullets = toBulletRuns(portfolioSummary);
  const financialBullets = toBulletRuns(financialHighlights);
  const teamBullets = toBulletRuns(teamGovernance);

  addBulletsSection(
    slide,
    'Portfolio Summary',
    portfolioBullets,
    portfolio.yTitle,
    portfolio.yBody,
    hBody,
    slideImages.portfolio
  );
  addBulletsSection(
    slide,
    'Financial Highlights',
    financialBullets,
    financial.yTitle,
    financial.yBody,
    hBody,
    slideImages.financial
  );
  addBulletsSection(slide, 'Team & Governance', teamBullets, team.yTitle, team.yBody, hBody, slideImages.team);

  addConfidentialDisclaimer(slide);
}
